import {
  AppBar,
  Button,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

// eslint-disable-next-line react/prop-types
function NavBar({ handleChange, type, fetchRecieptNo }) {
  return (
    <div>
      {" "}
      <AppBar
        position="static"
        elevation={0}
        sx={{ bgcolor: "#324537", mb: 2 }}
      >
        <Toolbar>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
          >
            <Typography
              variant="h6"
              sx={{ flexGrow: 1, fontWeight: 700, color: "white" }}
            >
              {type === "RECEIPT" ? "Receipt" : "Payment"}
            </Typography>
            <Stack direction={"row"} gap={2} alignItems={"center"}>
              <ToggleButtonGroup
                value={type}
                exclusive
                onChange={handleChange}
                sx={{
                  bgcolor: "rgba(255,255,255,0.1)",
                  borderRadius: "8px",
                  p: "2px",
                }}
              >
                <ToggleButton
                  value="RECEIPT"
                  sx={{
                    textTransform: "none",
                    border: "none",
                    borderRadius: "6px",
                    color: "white",
                    px: 1.5,
                    py: 0.3, 
                    fontSize: "0.8rem", 
                    minHeight: "28px",  
                    "&.Mui-selected": {
                      bgcolor: "white",
                      color: "#324537",
                      fontWeight: 600,
                    },
                  }}
                >
                  Receipt
                </ToggleButton>

                <ToggleButton
                  value="PAYMENT"
                  sx={{
                    textTransform: "none",
                    border: "none",
                    borderRadius: "6px",
                    color: "white",
                    px: 1.5,
                    py: 0.3,
                    fontSize: "0.8rem",
                    minHeight: "28px",
                    "&.Mui-selected": {
                      bgcolor: "white",
                      color: "#324537",
                      fontWeight: 600,
                    },
                  }}
                >
                  Payment
                </ToggleButton>
              </ToggleButtonGroup>

              <Link to="/counterBilling" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "rgba(255,255,255,0.2)",
                    "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
                    textTransform: "none",
                    color: "white",
                  }}
                >
                  Counter Bill
                </Button>
              </Link>
              <Link to="/" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "rgba(255,255,255,0.2)",
                    "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
                    textTransform: "none",
                    color: "white",
                  }}
                >
                  Home
                </Button>
              </Link>
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default NavBar;
